const inStandalone =
    matchMedia("(display-mode: standalone)").matches ||
    (navigator as unknown as { standalone: boolean }).standalone === true;

export const config = {
    unlockAll: import.meta.env.VITE_UNLOCK_ALL === "true" || localStorage.getItem("unlock-all") === "true",
    appName: import.meta.env.VITE_APP_NAME,
    inStandalone,
};